/* tslint:disable */
/* eslint-disable */
/**
 * timelight
 * This is the timelight api.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum TaskStatus {
  Waiting = "waiting",
  Active = "active",
  Failed = "failed",
  Killed = "killed",
  Completed = "completed",
}

export function TaskStatusFromJSON(json: any): TaskStatus {
  return TaskStatusFromJSONTyped(json, false)
}

export function TaskStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskStatus {
  return json as TaskStatus
}

export function TaskStatusToJSON(value?: TaskStatus | null): any {
  return value as any
}
